import script from "./ReUploadVideoSourceFileModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./ReUploadVideoSourceFileModal.vue?vue&type=script&lang=ts&setup=true"

import "./ReUploadVideoSourceFileModal.vue?vue&type=style&index=0&id=da2da3c8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-da2da3c8"]])

export default __exports__